
import React from 'react'
import { Select, Button, message, Modal, Input } from 'antd';
import Config from "../../../config/Config";
import WidgetAjax from '../../../widget/WidgetAjax';
import WidgetMessage from "../../../widget/WidgetMessage";
import { CloseOutlined } from '@ant-design/icons';
let path = Config.getBasePath();
let filePath = Config.getFilePath();

class choiceExpect extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      jobMdal: false,//期望岗位弹窗
      jobTypeList: [],//岗位数据
      selectTabValue: 0,
      selectJobTags: [],
      selectJobTagsName: [],
      placeModal: false, //地区
      placeList: [], //地区数据
      selectPlaceTags: [],
      selectPlaceTagsName: [],

    }
  }
  async componentDidMount() {
    this.getUserInfo();
    this.getJobList();
    this.getAreaData();
  }

  componentWillUnmount() {

  }


  // 获取岗位类型 
  getJobList = (value) => {
    const onGetJobData = (res) => {
      if (res.status == 0) {
        this.setState({
          jobTypeList: res.results.map(item => {
            return { ...item, title: item.name, value: item.code }
          })
        })
      }
    }
    WidgetAjax.ajax({ url: path + '/recruitment/job_type', params: { parent_code: "0", word: value }, callback: onGetJobData })
  }

  // 获取地区
  getAreaData = () => {
    const onGetAreaData = (res) => {
      if (res.status == 0) {
        this.setState({ placeList: res.results[0].children })
      }
    }
    WidgetAjax.ajax({ url: path + '/recruitment/district', params: {}, callback: onGetAreaData })
  }

  // 获取用户简历信息
  getUserInfo = () => {
    let useInfo = JSON.parse(sessionStorage.getItem('_user_info_'))

    this.setState({
      infoLoading: true,
    })
    const onGetData = (res) => {
      if (res.status == 0) {
        let intention = res.result?.intention;
        this.setState({ intention })
      }
    }
    WidgetAjax.ajax({ url: path + "/applicant/resume_info", params: { id: useInfo.extensions.applicant_id }, callback: onGetData }, this.props)
  }

  jobSearch = (value) => {
    this.getJobList(value)
  }

  jobConfirm = () => {
    const { selectJobTagsName } = this.state;
    let jobName;
    if (selectJobTagsName && selectJobTagsName.length > 0) {
      jobName = selectJobTagsName.map(item => item.name).join(',');

    }
    this.setState({ jobMdal: false, jobName });
  }
  placeConfirm = () => {
    const { selectPlaceTagsName } = this.state;
    let placeName;
    if (selectPlaceTagsName && selectPlaceTagsName.length > 0) {
      placeName = selectPlaceTagsName.map(item => item.name).join(',');

    }
    this.setState({ placeModal: false, placeName });
  }


  issue = () => {
    const { intention, selectPlaceTags, selectJobTags } = this.state;
    let params = {
      ...intention,
      PROPERTY: intention.PROPERTY && intention.PROPERTY[0] ? [intention.PROPERTY[0].value] : [],
      DISTRICT: selectPlaceTags,
      JOBTYPE: selectJobTags
    }
    console.log(params, 'params');
    const onIssue = (res) => {
      if (res.status == 0) {
        message.success("发布成功!");
        setTimeout(() => {
          this.props.history.push({ pathname: '/home/homepage' });
        }, 1200);
      } else {
        message.error("发布失败!请重试" + res.message);
      }
    }
    WidgetAjax.ajax({ url: path + '/applicant/update_intention', params: params, callback: onIssue })
  }


  render() {
    const { page, jobMdal, jobTypeList, selectTabValue, selectJobSecond = 0,
      selectJobTags, selectJobTagsName, placeModal, placeList, selectPlaceTags, selectPlaceTagsName, jobName = undefined, placeName = undefined } = this.state;

    return <div component-data="choiceExpect">
      <div className={page == 1 ? 'box_1200_1' : 'box_1200_2'} >
        {
          page == 1 ?
            <div className='expect-box'>
              <div className='icon-expect'>
                <img src={require("../../../img/pinzhunzhun/personalCenter/expected-position-icon.png")} />
              </div>
              <Button type="primary" onClick={() => { this.setState({ page: page + 1 }) }}>快速发布简历</Button>
            </div>
            :
            <div className='expect-sel-box'>
              <div className='side-slide-box'>
                <div className='side-title'>您想找什么样的工作？</div>
                <div className='icon-expect1'>
                  <img src={require("../../../img/pinzhunzhun/personalCenter/expected-position-icon1.png")} />
                </div>
              </div>
              <div className='expect-form-content'>
                <div className='expect-title'>求职期望</div>
                <div className='expect-form'>
                  <Select placeholder={placeName ? placeName : "选择城市"}
                    variant="filled"
                    dropdownRender={() => null}
                    allowClear={false}
                    onClick={() => { this.setState({ placeModal: true }) }}
                  />
                  <div className='expect-form-label-tips'>您期望的职位是</div>
                  <Select placeholder={jobName ? jobName : "选择职位类型"}
                    variant="filled"
                    dropdownRender={() => null}
                    allowClear={false}
                    onClick={() => { this.setState({ jobMdal: true }) }} />
                </div>
                <Button type="primary" onClick={() => { this.issue() }}>发布</Button>
              </div>
            </div>
        }

      </div>




      <div className='resume_wrap'>
        <Modal
          title="期望岗位选择"
          visible={jobMdal}
          centered
          footer={[
            <Button type="primary" onClick={() => {
              this.jobConfirm();
            }}>
              确认
            </Button>,
          ]}
          onCancel={() => {
            this.setState({
              jobMdal: false,
              selectTabValue: 0,
            })
            return false
          }}
          getContainer={false}
          width={890}
          wrapClassName="job_wrap_box"
        >
          <div className="job_search_box">
            <Input onChange={(e) => this.jobSearch(e.target.value)} />
          </div>
          <div className="laogong_job">
            <ul className="laogong_job_left">
              {
                jobTypeList.map((item, index) => {
                  return <li
                    key={index}
                    onClick={() => this.setState({ selectTabValue: index, selectJobSecond: 0 })}
                    className={selectTabValue == index ? "laogong_job_left_active" : ""}
                  >{item.name}</li>
                })
              }
            </ul>
            <ul className="laogong_job_right">
              {
                jobTypeList[selectTabValue] && jobTypeList[selectTabValue].children && jobTypeList[selectTabValue].children.length > 0 ?
                  jobTypeList[selectTabValue].children.map((item, index) => {
                    return <li
                      onClick={async () => {
                        this.setState({
                          selectJobSecond: index,
                        })
                      }}
                      key={index}
                      className="laogong_job_right_second"
                    >
                      <span>{item.name}</span>
                      {
                        selectJobSecond == index
                          ? <img src={require('../../../img/pinzhunzhun/resume/select.svg')} />
                          : <></>
                      }
                    </li>
                  })
                  : <></>
              }
              <div className="laogong_job_right_third">
                {
                  jobTypeList[selectTabValue] && jobTypeList[selectTabValue].children && jobTypeList[selectTabValue].children.length > 0
                    ? jobTypeList[selectTabValue].children[selectJobSecond].children.map((citem, cindex) => {
                      return <div
                        key={cindex}
                        className={`laogong_job_right_third_item ${selectJobTags.includes(citem.code) ? "laogong_job_right_third_active" : ""}`}
                        onClick={async () => {
                          if (!selectJobTags.includes(citem.code)) {
                            if (selectJobTags.length >= 5) {
                              WidgetMessage.warning('最多只可选5个职位！')
                            } else {
                              await this.setState({
                                selectJobTags: [
                                  ...selectJobTags,
                                  citem.code,
                                ],
                                selectJobTagsName: [
                                  ...selectJobTagsName,
                                  citem,
                                ],
                              })
                            }
                          } else {
                            await this.setState({
                              selectJobTags: selectJobTags.filter(vitem => vitem !== citem.code),
                              selectJobTagsName: selectJobTagsName.filter(vitem => vitem.code !== citem.code),
                            })
                          }
                        }}
                      >{citem.name}</div>
                    })
                    : <></>
                }
              </div>
            </ul>
          </div>
          <div className="has_select_wrap">
            <div className="has_select_top">
              <div className="has_select_title">我选择的岗位</div>
              <div className="has_select_num">已选{selectJobTagsName.length} / 5</div>
            </div>
            <ul>
              {
                selectJobTagsName.map((item, index) => {
                  return <li key={index} className="laogong_job_right_item">
                    {item.name}
                    <span className="has_select_close" onClick={async () => {
                      await this.setState({
                        selectJobTags: selectJobTags.filter(vitem => vitem !== item.code),
                        selectJobTagsName: selectJobTagsName.filter(vitem => vitem.code !== item.code),
                      })
                    }}>
                      <CloseOutlined />
                    </span>
                  </li>
                })
              }
            </ul>
          </div>
        </Modal>
        <Modal
          title="期望工作地选择"
          visible={placeModal}
          centered
          footer={[
            <Button type="primary" onClick={() => {
              this.placeConfirm();
            }}>
              确认
            </Button>,
          ]}
          onCancel={() => {
            this.setState({
              placeModal: false,
              selectTabValue: 0,
            })
            return false
          }}
          getContainer={false}
          width={890}
          wrapClassName="job_wrap_box"
        >
          <div className="laogong_job">
            <ul className="laogong_job_left">
              {
                placeList.map((item, index) => {
                  return <li
                    key={index}
                    onClick={() => this.setState({ selectTabValue: index })}
                    className={selectTabValue == index ? "laogong_job_left_active" : ""}
                  >{item.name}</li>
                })
              }
            </ul>
            <ul className="laogong_job_right">
              {
                placeList[selectTabValue] && placeList[selectTabValue].children && placeList[selectTabValue].children.length > 0 ?
                  placeList[selectTabValue].children.map((item, index) => {
                    return <li onClick={async () => {
                      if (!selectPlaceTags.includes(item.code)) {
                        if (selectPlaceTags.length >= 5) {
                          WidgetMessage.warning('最多只可选5个地区！')
                        } else {

                          await this.setState({
                            selectPlaceTags: [
                              ...selectPlaceTags,
                              item.code,
                            ],
                            selectPlaceTagsName: [
                              ...selectPlaceTagsName,
                              item,
                            ],
                          })
                        }
                      } else {
                        await this.setState({
                          selectPlaceTags: selectPlaceTags.filter(vitem => vitem !== item.code),
                          selectPlaceTagsName: selectPlaceTagsName.filter(vitem => vitem.code !== item.code),
                        })
                      }
                    }} key={index} className={selectPlaceTags.includes(item.code) ? "laogong_job_right_active" : ""}>{item.name}</li>
                  })
                  : <></>
              }
            </ul>
          </div>
          <div className="has_select_wrap">
            <div className="has_select_top">
              <div className="has_select_title">我选择的地区</div>
              <div className="has_select_num">已选{selectPlaceTagsName.length} / 5</div>
            </div>
            <ul>
              {
                selectPlaceTagsName.map((item, index) => {
                  return <li key={index} className="laogong_job_right_item">
                    {item.name}
                    <span className="has_select_close" onClick={async () => {
                      await this.setState({
                        selectPlaceTags: selectPlaceTags.filter(vitem => vitem !== item.code),
                        selectPlaceTagsName: selectPlaceTagsName.filter(vitem => vitem.code !== item.code),
                      })
                    }}>
                      <CloseOutlined />
                    </span>
                  </li>
                })
              }
            </ul>
          </div>
        </Modal>

      </div>



    </div>
  }
}

export default choiceExpect;